import {SET_NOTIFICATIONS} from "./notifications-types";

export const setNotifications = (notifications) => ({type: SET_NOTIFICATIONS, notifications})